/// <reference types="node" />
import * as highcharts from "highcharts";

highcharts.setOptions({
  lang: {
    decimalPoint: ".",
    thousandsSep: ",",
  },
});

// tslint:disable-next-line:no-var-requires
const drilldown = require("highcharts/modules/drilldown");
drilldown(highcharts);
let performedDrill = false;
import { Component, h } from "preact";
import colors from "../utils/colors";

declare module "highcharts" {
  // tslint:disable-next-line:interface-name
  export interface PointObject {
    doDrilldown(aug1: boolean): void;
  }
}

interface IProps {
  data: Highcharts.SeriesOptionsType[];
  drillDownData: Highcharts.SeriesOptionsType[];
  height?: number;
  width?: number;
  pointIndex?: number;
  onDrilledDown?: (pointIndex?: number) => void;
}

export default class PieChart extends Component<IProps> {
  private divElement?: HTMLDivElement;
  private chart?: Highcharts.Chart;
  private reflowIntervalHandle?: number;

  public componentDidMount() {
    this.createChart();
    this.reflowIntervalHandle = window.setInterval(() => {
      if (this.chart !== undefined) {
        this.chart.reflow();
      }
    }, 500);
  }

  public componentDidUpdate(prevProps: IProps, prevState: any) {
    if (this.props !== prevProps || this.state !== prevState) {
      this.createChart();
    }
  }

  public shouldComponentUpdate(nextProps: IProps): boolean {
    return false;
  }

  // Destroy chart before unmount.
  public componentWillUnmount() {
    window.clearInterval(this.reflowIntervalHandle);
    if (this.chart) {
      this.chart.destroy();
    }
  }

  public render(props: IProps, state: {}) {
    return (
      <div
        id="container"
        style="width: 100%; height: 100%"
        ref={e => (this.divElement = e as HTMLDivElement)}
      />
    );
  }

  public getChartOptions(): Highcharts.Options {
    return {
      chart: {
        events: {
          drilldown: (e: any) => {
            if (!performedDrill) {
              performedDrill = !performedDrill;
              if (this.props.onDrilledDown) {
                this.props.onDrilledDown(e.point.index);
              }
            }
          },
          drillup: (e: any) => {
            if (performedDrill) {
              performedDrill = !performedDrill;
              if (this.props.onDrilledDown) {
                this.props.onDrilledDown(undefined);
              }
            }
          },
        },
        renderTo: this.divElement,
        type: "pie",
      },
      colors,
      credits: {
        enabled: false,
      },
      // drilldown :Can be sent as empty in case of normal pie chart
      drilldown: {
        series: this.props.drillDownData,
      },
      legend: {
        labelFormat: "{name}: {percentage:.0f}%",
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            distance: 1,
            enabled: true,
            format: "{point.name}: {point.percentage:.0f}%",
          },
          showInLegend: false,
        },
      },
      series: this.props.data,
      title: {
        text: "",
      },
      tooltip: {
        borderColor: "#ccc",
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span>: <b>{point.percentage:.0f}% ({point.y:,.0f} K€) </b><br/>',
      },
    };
  }

  private createChart() {
    if (this.chart) {
      this.chart.destroy();
    }
    this.chart = new highcharts.Chart(this.getChartOptions());

    if (this.props.pointIndex !== null && this.props.pointIndex !== undefined) {
      this.chart.series[0].data[this.props.pointIndex].doDrilldown(false);
    }
  }
}
